import React from 'react';

import { Home } from './Home';
import { ImportContext } from './importContext';
import { useImportContext } from './useImportContext';
export default function Import() {
  const importContextValue = useImportContext();

  return (
    <ImportContext.Provider value={importContextValue}>
      <Home />
    </ImportContext.Provider>
  );
}
